import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductViewSpecificationComponent } from '../view-specification/product-view-specification.component';
import { CommonModule } from '@angular/common';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
@Component({
    selector: 'product-view-specification-icms',
    templateUrl: 'product-view-specification-icms.html',
    styleUrls: ['./product-view-specification-icms.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, SizeClassDirective]
})
export class ProductViewSpecificationIcmsComponent extends ProductViewSpecificationComponent {
}
